import {
  ACTION_ARGS,
  COMPONENT_STATE_ARGS,
  CONTAINER_ARGS,
  CONTENT_ARGS,
  pickArgs,
} from '../../../../../utils/spds/metadata';
import { on } from '@ember/modifier';
import SecondaryButton from '../secondary.gjs';
import Super from '../../../core/base.gjs';

const METADATA = {
  component: 'Spds::Action::Button::Filter::Trigger',
  description: 'Trigger button for filter menu',
  meta: {
    ...pickArgs(ACTION_ARGS, ['onClick']).meta,
    ...pickArgs(COMPONENT_STATE_ARGS, ['disabled', 'open']).meta,
    ...pickArgs(CONTAINER_ARGS, ['fitContent']).meta,
    ...pickArgs(CONTENT_ARGS, ['text']).meta,
  },
  name: 'Filter Trigger',
};

export default class SpdsActionButtonFilterTrigger extends Super {
  static metadata = this.setMetadata(METADATA);
  baseClass = 'spds-action-button-filter-trigger';
  componentName = 'Spds::Action::Button::Filter::Trigger';
  classesToMapToArgs = ['open'];

  <template>
    <SecondaryButton
      @disabled={{@disabled}}
      @fitContent={{@fitContent}}
      @text={{@text}}
      class={{this.classes}}
      data-test-spds-action-button-filter-trigger
      ...attributes
      {{this.validateArguments}}
      {{this.setupComponent}}
      {{on "click" @onClick}}
    >
      {{yield}}
    </SecondaryButton>
  </template>
}

export const ACTION_BUTTON_FILTER_TRIGGER_METADATA = SpdsActionButtonFilterTrigger.metadata;
